import { render } from "./Parameters.vue?vue&type=template&id=19d081d5&scoped=true"
import script from "./Parameters.vue?vue&type=script&lang=js"
export * from "./Parameters.vue?vue&type=script&lang=js"

import "./custom-parameters.scss?vue&type=style&index=0&id=19d081d5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d081d5"]])

export default __exports__